module.exports = __webpack_public_path__ + "static/media/oya.5e88125e.png";